import { create } from 'zustand';

export type UploadResultOutcome = 'success' | 'error';

interface UploadResultDialogState {
  open: boolean;
  outcome: UploadResultOutcome;
  title: string;
  message: string;
  showSuccess: (boardName: string) => void;
  showError: (message: string) => void;
  close: () => void;
}

export const useUploadResultDialogStore = create<UploadResultDialogState>((set) => ({
  open: false,
  outcome: 'success',
  title: '',
  message: '',
  showSuccess: (boardName) =>
    set({
      open: true,
      outcome: 'success',
      title: 'Upload complete',
      message: `Your sketch was compiled and uploaded to ${boardName}.`,
    }),
  showError: (message) =>
    set({
      open: true,
      outcome: 'error',
      title: 'Upload failed',
      message,
    }),
  close: () => set({ open: false }),
}));
